<template>
	<Portal :to="teleportTo" :disabled="!teleportTo">
		<div class="palta-card">
			<div class="card-form">
				<div v-show="rendered" id="checkout-form" class="checkout-form"></div>
				<CardSkeleton v-show="!rendered" />

				<slot name="beforeButton"></slot>

				<button @click="submit" class="btn btn-success mt-4 btn-submit text-bold" :class="buttonClassList">
					<LockIcon class="btn__icon" />
					<div class="btn__cta">{{ cta }}</div>
					<div class="spinner-border spinner-border-sm"></div>
				</button>
			</div>
		</div>
	</Portal>
</template>

<script>
import LockIcon from '@/components/icons/LockIcon.vue'
import CardSkeleton from './CardSkeleton'
import { Portal } from 'portal-vue'

export default {
	name: 'CardForm',

	components: {
		LockIcon,
		CardSkeleton,
		Portal
	},

	props: {
		cta: {
			type: String,
			required: true
		},
		buttonClassList: {
			type: Object,
			default: () => ({})
		},
		rendered: {
			type: Boolean,
			default: false
		},
		teleportTo: {
			type: String,
			default: null
		}
	},

	methods: {
		submit() {
			this.$emit('submit')
		}
	}
}
</script>

<!-- eslint-disable-next-line vue-scoped-css/enforce-style-type -->
<style lang="scss">
.palta-card {
	svg {
		display: inline;
		width: auto;
	}

	.btn-submit {
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;

		&:focus,
		&:active {
			box-shadow: none;
		}

		svg {
			margin-right: 0.6rem;
		}

		.spinner-border {
			position: absolute;
			left: 50%;
			top: 50%;
			margin-top: -0.68rem;
			margin-left: -0.68rem;
			opacity: 0;
		}

		&.loading {
			.spinner-border {
				opacity: 1;
			}
			.btn__icon,
			.btn__cta {
				opacity: 0;
			}
		}
	}
}

.checkout-form {
	div:empty {
		display: none;
	}

	[data-testid='FormInputGroups'] {
		div:only-child {
			max-width: 100%;
		}
	}
}

.PrimerCheckout {
	&__apmButton {
		height: auto !important;
	}

	&__apmButtonContainer {
		&:not(:last-child) {
			margin-bottom: 0 !important;
		}
	}

	@media (max-width: 600px) {
		&__formField {
			&.PrimerCheckout__formField--dual {
				flex-direction: row !important;
				gap: 16px;

				& > {
					.PrimerCheckout__formField + .PrimerCheckout__formField {
						margin-top: 0 !important;
					}
				}
			}
		}
	}
}
</style>
